import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";

import Header from "./Components/Français/Home/Header/Header";
import Apropos from "./Components/Français/Home/Apropos/Apropos";
import VH from "./Components/Français/Home/Visite&Horraire/VH";
import Plan from "./Components/Français/Home/Plan/Plan";
import Photos from "./Components/Français/Home/Photos/Photos";
import ReviewH from "./Components/Français/Home/ReviewH/ReviewH";
import Contact from "./Components/Français/Home/Contact/Contact";
import Footer from "./Components/Français/Home/Footer/Footer";

import Infos from "./Components/Français/Infos/Infos";
import FAQ from "./Components/Français/FAQ/FAQ";
import Review from "./Components/Français/Review/Review";
import ContactPage from "./Components/Français/ContactPage/ContactPage";
import Galerie from "./Components/Français/Galerie/Galerie";

import ScrollToTop from "./Components/Français/ScrollToTop";
import Loading from "./Components/Français/LoadingPage/Loading";

function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true); // Track if it's the first load

  // ✅ Init AOS once
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
      mirror: false,
    });
  }, []);

  // ✅ Handle loading on initial app load (wait for window to fully load)
  useEffect(() => {
    if (isInitialLoad) {
      const handleWindowLoad = () => {
        setIsLoading(false);
        AOS.refresh();
        setIsInitialLoad(false);
      };

      // If window is already loaded, hide immediately; else wait
      if (document.readyState === 'complete') {
        handleWindowLoad();
      } else {
        window.addEventListener('load', handleWindowLoad);
        return () => window.removeEventListener('load', handleWindowLoad);
      }
    }
  }, [isInitialLoad]);

  // ✅ Handle loading on route changes (fallback to timeout since window.load doesn't re-fire)
  useEffect(() => {
    if (!isInitialLoad) { // Only for subsequent route changes
      setIsLoading(true);

      const timer = setTimeout(() => {
        setIsLoading(false);
        AOS.refresh();
      }, 1500); // Increased to 1500ms for better buffer (adjust as needed, e.g., 2000ms for slower pages)

      return () => clearTimeout(timer);
    }
  }, [location.pathname, isInitialLoad]);
  return (
    <>
      {isLoading && <Loading />}
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <Apropos />
              <VH />
              <Photos />
              <Plan />
              <ReviewH />
              <Contact />
            </>
            }
        />
        <Route path="/Infos" element={<Infos />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route path="/Review" element={<Review />} />
        <Route path="/ContactPage" element={<ContactPage />} />
        <Route path="/Galerie" element={<Galerie />} />
      </Routes>
      <Footer />
    </>
  );
}

export default AppContent;